<template>
    <CHeader position="sticky" class="mb-3 white">
        <CContainer fluid>
            <CHeaderToggler
                class="ps-1"
                @click="$store.commit('toggleSidebar')"
            >
                <CIcon icon="cil-menu" size="lg" />
            </CHeaderToggler>
            <CHeaderNav>
                <AppHeaderDropdownAccnt
                    @getVacation="getVacation"
                    @showEvent="showEvent"
                    @getDayOff="getDayOff"
                />
            </CHeaderNav>
        </CContainer>
        <CHeaderDivider />
        <CContainer fluid>
            <AppBreadcrumb />
        </CContainer>
    </CHeader>
</template>

<script>
import AppBreadcrumb from '@/components/base/AppBreadcrumb.vue'
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'

export default {
    name: 'AppHeader',
    emits: ['getVacation', 'getDayOff', 'showEvent'],
    components: {
        AppBreadcrumb,
        AppHeaderDropdownAccnt,
    },
    methods: {
        getVacation() {
            this.$emit('getVacation', true)
        },
        getDayOff() {
            this.$emit('getDayOff', true)
        },
        showEvent(item, type) {
            this.$emit('showEvent', item, type)
        },
    },
}
</script>
<style>
.header.header-sticky {
  z-index: 1000;
}

.white {
  background-color: white;
}
</style>
